
export { Locales } from "./components/Layout/Locales"